import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { ArrowCta, FormCard, Heading, VStack, Text } from 'components/ui';

import { useFormData } from '../../utils/formReducer.js';
import { useGoogleTagManager } from '../../hooks/useGoogleTagManager';
import SignUpInfo from './SignUpInfo';
import {
  FORM_VIEW,
  FormViews,
  TRACKING_ONBOARDING_COMPLETED,
  TRACKING_PURCHASE_LOCAL_STORAGE_KEY,
} from './constants';
import TOSInput from './TOSInput';
import HeaderNav from '../HeaderNav/HeaderNav';
import { StickyCtaLayout } from '../ui/StickyCtaLayout';
import { ContactSupport } from './ContactSupport';
import { useReferrer } from '../../hooks/useReferrer';
import { UHC_STORE_UTM_SOURCE } from '../../constants/utms';
import { useBirthdayInput } from './components/BirthdayInput/useBirthdayInput';
import { BirthdayInput } from './components/BirthdayInput/BirthdayInput';

// 18_last_step_page
const EndOfFlow = ({ handleSubmit, apiError }) => {
  const { state: formData, dispatch } = useFormData();
  const [tosChecked, setTosChecked] = useState(false);
  const referrer = useReferrer();
  const isSamlConnection = !!referrer?.is_saml;
  const isUhcStore = referrer?.utm_source === UHC_STORE_UTM_SOURCE;
  const { birthdayError, handleBirthdayChange, validateBirthday } =
    useBirthdayInput();

  const { trackEventInGoogleTagManager } = useGoogleTagManager();

  const handleNext = () => {
    if (!validateBirthday(formData.birthday || '')) {
      return;
    }

    // set this flag to track the purchase, we will clear it once
    // we track it in the thank you page
    localStorage.setItem(TRACKING_PURCHASE_LOCAL_STORAGE_KEY, true);

    trackEventInGoogleTagManager(TRACKING_ONBOARDING_COMPLETED);

    handleSubmit();
  };

  const isFormValid = (formData) => {
    if (birthdayError) return false;

    if (
      !formData.firstName ||
      !/[a-zA-Z]/g.test(formData.firstName) ||
      !formData.lastName ||
      !/[a-zA-Z]/g.test(formData.lastName) ||
      !formData.email ||
      formData.email.indexOf('@') < 0 ||
      (!formData.selected_affiliate && formData.affiliate_name) ||
      !tosChecked
    ) {
      return false;
    }

    return true;
  };

  return (
    <StickyCtaLayout
      actionArea={
        <>
          <ArrowCta
            mb={4}
            disabled={!isFormValid(formData)}
            onClick={handleNext}
          >
            Next
          </ArrowCta>

          <ContactSupport />
        </>
      }
      header={
        <HeaderNav
          screenName={FORM_VIEW[FormViews.endOfFlow].trackingLabel}
          showWhatIsAybleModal
        />
      }
      maxWidth="formWidth"
    >
      <VStack flex={1} w="100%">
        <Heading textStyle="heading.h2" maxW={'100%'} textAlign={'left'}>
          {isSamlConnection ? (
            'Confirm your account details'
          ) : (
            <>
              Let's check if Ayble is
              <br />
              covered for you.
            </>
          )}
        </Heading>

        {apiError && (
          <Box
            mt={4}
            borderColor={'red.500'}
            borderWidth={1}
            backgroundColor={'red.100'}
            p={3}
          >
            <Text fontWeight="bold" color={'red.500'}>
              {apiError}
            </Text>
          </Box>
        )}

        <FormCard mt={4}>
          <SignUpInfo formData={formData} dispatch={dispatch} />

          <BirthdayInput
            birthdayError={birthdayError}
            birthday={formData.birthday || ''}
            handleBirthdayChange={handleBirthdayChange}
          />

          <TOSInput
            tosChecked={tosChecked}
            handleTosChange={() => setTosChecked((prevState) => !prevState)}
          />
        </FormCard>

        {isUhcStore && (
          <Box maxW={480} my={2}>
            <Text fontStyle={'italic'} color={'secondary.200'}>
              Note: Ayble is not medical advice. It is not intended for
              individuals who who are pregnant or report mental health
              conditions. Contact support@ayblehealth.com if you have questions.
            </Text>
          </Box>
        )}
      </VStack>
    </StickyCtaLayout>
  );
};

export default EndOfFlow;
